/**
 * 判断 url 是否为照片
 * @param url
 */
export const isImg = (url = '') => {
  if (!url) return false;
  try {
    // 尝试用 URL 解析，取 pathname
    const u = new URL(url, window.location.origin);
    url = u.pathname;
  } catch {
    // fallback: 去掉 query/hash
    url = url.split('?')[0].split('#')[0];
  }
  // 图片后缀，预览图中如果是图片需要显示照片内容，否则显示文件类型图标
  const imgSuffixes = ['.bmp', '.jpg', '.jpeg', '.png', '.gif', '.webp', '.ico', '.svg', 'avif', '.jxl'];
  return imgSuffixes.some(imgSuffix => {
    return url && url.toLowerCase().endsWith(imgSuffix);
  })
}

/**
 * 将图片URL转换为Base64格式
 * @param url 图片URL
 * @param onSuccess 成功回调函数
 * @param onError 错误回调函数
 * @param onLoading 加载状态回调函数（可选）
 */
export const convertImageToBase64 = (
  url: string,
  onSuccess: (base64: string) => void,
  onError: (error: string) => void,
  onLoading?: (loading: boolean) => void
): void => {
  // 开始加载
  onLoading?.(true);

  fetch(url, {
    mode: 'cors', // 明确指定CORS模式
    credentials: 'omit' // 不发送凭证
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.blob();
    })
    .then(blob => {
      const reader = new FileReader();
      reader.onload = function() {
        const base64String = reader.result as string;
        onLoading?.(false);
        onSuccess(base64String);
      };
      reader.onerror = function() {
        onLoading?.(false);
        onError('Base64转换失败');
      };
      reader.readAsDataURL(blob);
    })
    .catch(error => {
      onLoading?.(false);
      console.error('转换Base64失败:', error);
      if (error.message.includes('CORS')) {
        onError('跨域访问被限制，请联系管理员配置CORS');
      } else {
        onError('获取图片失败，请稍后重试');
      }
    });
};
